// extracted by mini-css-extract-plugin
module.exports = {"wrapperActionLink":"DistributionComponent_wrapperActionLink__1Cx6q","wrapperActionLinkDisabled":"DistributionComponent_wrapperActionLinkDisabled__2NILg"};